import { getEnvironment } from 'src/lib/featureFlags';

export const useGenericWebhooks = getEnvironment().useGenericWebhooks;
export const webhooksUrlPrefix = getEnvironment().integrationServiceBaseUrl;

export function isPagerDutyWebhookForCurrentEnv(w) {
  if (useGenericWebhooks) {
    return w.endpoint_url && w.endpoint_url.startsWith(webhooksUrlPrefix);
  }
  return !w.endpoint_url;
}
